import Vue from 'vue'
import Vuex from 'vuex'
import menu from './modules/menu'
import base from './modules/base'
import userInfo from './modules/userInfo'
import components from './modules/components'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    menu,base,userInfo,components
  },
  strict: debug
})


// WEBPACK FOOTER //
// ./src/store/index.js